import { useForm } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { useBlockAutoReload } from "@/lib/standalone-recovery"

export default function Login({ flash }: { flash?: { alert?: string } }) {
  const { data, setData, post, processing, errors } = useForm({
    email_address: "",
    password: "",
  })

  // Don't let the standalone recovery reload wipe typed credentials mid-entry.
  useBlockAutoReload(!processing && (data.email_address !== "" || data.password !== ""))

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post("/session")
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-md space-y-8 px-4">
        <div className="text-center">
          <h1 className="text-3xl font-bold tracking-tight">Brain Down</h1>
          <p className="mt-2 text-sm text-muted-foreground">Sign in to your account</p>
        </div>

        {flash?.alert && (
          <div className="rounded-md bg-destructive/10 p-3 text-sm text-destructive">
            {flash.alert}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="email_address" className="text-sm font-medium">
              Email
            </label>
            <input
              id="email_address"
              type="email"
              value={data.email_address}
              onChange={(e) => setData("email_address", e.target.value)}
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              required
              autoFocus
            />
            {errors.email_address && (
              <p className="text-sm text-destructive">{errors.email_address}</p>
            )}
          </div>

          <div className="space-y-2">
            <label htmlFor="password" className="text-sm font-medium">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={data.password}
              onChange={(e) => setData("password", e.target.value)}
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              required
            />
            {errors.password && (
              <p className="text-sm text-destructive">{errors.password}</p>
            )}
          </div>

          <Button type="submit" className="w-full" disabled={processing}>
            {processing ? "Signing in..." : "Sign in"}
          </Button>
        </form>

      </div>
    </div>
  )
}
